const moduleRoute = {
  path: '/repasse_medico',
  component: () => import('@/views/Home.vue'),
  children: [
    {
      path: '',
      component: () => import('./views/Home.vue'),
      children: [
        // Relatório em React (MU-6D PR6). Rota para o deep link; a aba é
        // montada pelo Tab do Home, como as irmãs.
        {
          path: 'relatorio_de_repasse',
          component: () =>
            import('@/views/Financeiro/RepasseRelatorioReact.vue')
        },
        // Produção em React (MU-6D PR5). Rota para o deep link; a aba é
        // montada pelo Tab do Home, como as irmãs.
        {
          path: 'producao',
          component: () => import('@/views/Financeiro/RepasseProducaoReact.vue')
        },
        // Extratos em React (MU-6D). Rota para o deep link; a aba é montada
        // pelo Tab do Home.
        {
          path: 'extratos',
          component: () => import('@/views/Financeiro/RepasseExtratosReact.vue')
        },
        // Fechamento consolidado (MU-6B/4). A rota existe para o deep link
        // e para o pushState de `Home.vue` ter destino; a tela é montada
        // pelo Tab, como as irmãs.
        {
          path: 'fechamento',
          component: () =>
            import('@/views/Financeiro/RepasseFechamentoReact.vue')
        },
        // Perfis em React (MU-6D). Como Fechamento e Configurações, a rota
        // existe para o deep link; a aba é montada pelo Tab do Home.
        {
          path: 'perfis',
          component: () => import('@/views/Financeiro/RepassePerfisReact.vue')
        },
        // Regras em React (MU-6D). Rota para o deep link; a aba é montada
        // pelo Tab do Home. As SUB-TELAS da regra (/regras_repasse/:id/*)
        // seguem em Vue.
        {
          path: 'regras_de_repasse',
          component: () => import('@/views/Financeiro/RepasseRegrasReact.vue')
        },
        // Configurações em React (MU-6D). Como o Fechamento, a rota existe
        // para o deep link; a aba em si é montada pelo Tab do Home.
        {
          path: 'configuracoes',
          component: () =>
            import('@/views/Financeiro/RepasseConfiguracoesReact.vue')
        }
      ]
    }
  ]
}

// "Minha Produção" (perfil médico): produção travada no próprio profissional,
// fora das abas do repasse — o médico não vê o restante do módulo.
// Path com HÍFEN, como o resto do menu Funcionalidades
// (/configuracoes-da-clinica, /relatorios-gerenciais, /visao-geral) — só as
// rotas antigas do repasse usam underscore. O alias com underscore fica porque
// foi o path da primeira versão: sem ele, quem digitar/guardar a URL antiga cai
// numa tela 100% branca (o router não tem rota de fallback para path sem match).
const moduleRouteMyProduction = {
  path: '/minha-producao',
  alias: '/minha_producao',
  component: () => import('@/views/Home.vue'),
  children: [
    {
      path: '',
      component: () => import('./views/MyProduction.vue')
    }
  ]
}

// Sub-telas da regra em React (MU-6D PR4b). Antes eram um `Index.vue` pai com
// três filhas de rota que ele NUNCA renderizava (as abas eram `v-if`, não
// `<router-view>`) — agora é uma rota por aba, e a aba ativa desce por prop.
const moduleRouteRules = {
  path: '/regras_repasse',
  component: () => import('@/views/Home.vue'),
  children: [
    {
      path: ':id/:tab',
      component: () => import('@/views/Financeiro/RepasseRegraDetalheReact.vue')
    },
    // Sem aba na URL, cai em Definições (era o default do `getPathByIndex`).
    {
      path: ':id',
      redirect: ':id/definicoes'
    }
  ]
}

export default router => {
  router.addRoute(moduleRoute)
  router.addRoute(moduleRouteMyProduction)
  router.addRoute(moduleRouteRules)
}
